<script setup lang="ts" generic="TData">
import type { Column, HeaderGroup } from '@tanstack/vue-table'
import type { CSSProperties } from 'vue'
import { FlexRender } from '@tanstack/vue-table'
import { TableHead, TableHeader, TableRow } from '#ui-kit/ui/table'

defineProps<{
  headerGroups: HeaderGroup<TData>[]
  cellAttrs: (column: Column<TData>) => { class?: string; style: CSSProperties }
}>()

function ariaSort(column: Column<TData>): 'ascending' | 'descending' | 'none' | undefined {
  if (column.columnDef.enableSorting !== true || !column.getCanSort()) {
    return undefined
  }

  switch (column.getIsSorted()) {
    case 'asc':
      return 'ascending'
    case 'desc':
      return 'descending'
    default:
      return 'none'
  }
}
</script>

<template>
  <TableHeader>
    <TableRow v-for="headerGroup in headerGroups" :key="headerGroup.id" class="px-2">
      <TableHead
        v-for="header in headerGroup.headers"
        :key="header.id"
        v-bind="cellAttrs(header.column)"
        :aria-sort="ariaSort(header.column)"
      >
        <FlexRender
          v-if="!header.isPlaceholder"
          :render="header.column.columnDef.header"
          :props="header.getContext()"
        />
      </TableHead>
    </TableRow>
  </TableHeader>
</template>
